import { DatePicker, Form } from "antd";
import React, { useState } from "react";
import dayjs from 'dayjs';
import { b2c2bDateFormat, departureDateFormat, categoryDobDisabledDate } from "../../../utils/antd.props";

// Can not select dates after today
const futureDates = (current) => {
  return current && current > dayjs().endOf('day');
};

const nonInfantDates = (current, departureDate) => {
  return current > dayjs().endOf("day") || current < dayjs().subtract(2, "year").startOf("day") || (departureDate && current > dayjs(departureDate, departureDateFormat).toDate())
};

export default function AgeValidatorField(props) {
  const [mode, setMode] = useState("year");

  const validationByType = (current) => {
    switch (props.agegroup) {
      case "infant":
        return nonInfantDates(current, props.departuredate);

      default:
        if (props.category && props.childAgeRanges) {
          return categoryDobDisabledDate(current, props.category, props.departuredate, props.childAgeRanges);
        }
        return futureDates(current);
    }
  }

  return (
    <Form.Item {...props}>
      <DatePicker
        format={b2c2bDateFormat}
        disabledDate={(current)=>validationByType(current)}
        disabled={props.disabled}
        mode={mode}
        onOpenChange={(open) => { if (open) setMode("year"); }}
        onPanelChange={(_, newMode) => setMode(newMode)}
        onChange={(...args) => { setMode("year"); props.onChange?.(...args); }}
      />
    </Form.Item>
  )
}

AgeValidatorField.defaultProps = {
  label: "Date of Birth",
  name: "date_of_birth",
  agegroup: "adult"
}